import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {get,post} from '../../network/axiosServices';


const initialState = {
  loading: false,
  posts: [],
  error: '',
  detail: [],
  child: [],
  filter: [],
  settings: [],
  detailLoading: false,
  detailError: '',
  formLoading: false,
};

export const fetchPosts = createAsyncThunk('fetchDataHome', (params) => {
  return get(params);
});


export const fetchPostDetail = createAsyncThunk('fetchDataDetailHome', (params) => {
  return get(params);
});

export const postForm = createAsyncThunk('HomeForm', (params) => {
  return post(params);
});

export const fetchPostsChild = createAsyncThunk('fetchDataNewsChild', (params) => {
  return get(params);
});
export const fetchPostsChildFilter = createAsyncThunk('fetchDataNewsChildFilter', (params) => {
  return get(params);
});

export const fetchPostsSettings = createAsyncThunk('fetchDataSettings', (params) => {
  return get(params);
});

const postSlice = createSlice({
  name: 'posts',
  initialState,
  extraReducers: builder => {
    builder.addCase(fetchPosts.pending, (state) => {
      state.loading = true;
      state.posts = [];
      state.error = '';
    });
    builder.addCase(fetchPosts.fulfilled, (state, action) => {
      state.loading = false;
      state.posts = action.payload;
      state.error = '';
    });
    builder.addCase(fetchPosts.rejected, (state, action) => {
      state.loading = false;
      state.posts = [];
      state.error = action.error;
    });
    builder.addCase(fetchPostDetail.pending, (state, action) => {
      state.detailLoading = true;
      state.detail = [];
      state.detailError = '';
    });
    builder.addCase(fetchPostDetail.fulfilled, (state, action) => {
      state.detailLoading = false;
      state.detail = action.payload;
      state.detailError = '';
    });
    builder.addCase(fetchPostDetail.rejected, (state, action) => {
      state.detailLoading = false;
      state.detail = [];
      state.detailError = action.error;
    });
    builder.addCase(fetchPostsChild.pending, (state) => {
      state.loading = true;
      state.child = [];
      state.error = '';
    });
    builder.addCase(fetchPostsChild.fulfilled, (state, action) => {
      state.loading = false;
      state.child = action.payload;
      state.error = '';
    });
    builder.addCase(fetchPostsChild.rejected, (state, action) => {
      state.loading = false;
      state.child = [];
      state.error = action.error;
    });
    builder.addCase(postForm.pending, (state) => {
      state.loadingForm = true;
      state.success = [];
      state.error = '';
    });
    builder.addCase(postForm.fulfilled, (state, action) => {
      state.loadingForm = false;
      state.success = action.payload.message;
      state.error = '';

    });
    builder.addCase(postForm.rejected, (state, action) => {
      state.loadingForm = false;
      state.success = '';
      state.error = action.error;

    });

    builder.addCase(fetchPostsChildFilter.pending, (state) => {
      state.loading = true;
      state.filter = [];
      state.error = '';
    });
    builder.addCase(fetchPostsChildFilter.fulfilled, (state, action) => {
      state.loading = false;
      state.filter = action.payload;
      state.error = '';

    });
    builder.addCase(fetchPostsChildFilter.rejected, (state, action) => {
      state.loading = false;
      state.filter = '';
      state.error = action.error;

    });
    builder.addCase(fetchPostsSettings.pending, (state) => {
      state.loading = true;
      state.settings = [];
      state.error = '';
    });
    builder.addCase(fetchPostsSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.settings = action.payload;
      state.error = '';
    });
    builder.addCase(fetchPostsSettings.rejected, (state, action) => {
      state.loading = false;
      state.settings = [];
      state.error = action.error;
    });

  }
});


export default postSlice.reducer;
